import {UseQueryOptions} from '@tanstack/react-query';

import {api} from '@eksab/api';
import {useQuery} from '@eksab/hooks';

const queryKey = (competitionId: string) => ['competition-teams', competitionId];
const queryFn = (competitionId: string) =>
  api.get('v2/teams', {params: {competition: competitionId}}).then((res) => res.data.data);

export function useTeamsQuery(competitionId: string, options?: UseQueryOptions<Team[]>) {
  return useQuery<Team[]>(queryKey(competitionId), () => queryFn(competitionId), {
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}

useTeamsQuery.queryKey = queryKey;
useTeamsQuery.queryFn = queryFn;
